import React, { InputHTMLAttributes } from "react";
import { FieldError } from "react-hook-form";
import ErrorMessage from "./ErrorMessage";
type InputPropsType = InputHTMLAttributes<HTMLInputElement> & {
	label: string;
	error?: FieldError | string;
};

export const Input = React.forwardRef<HTMLInputElement, InputPropsType>((props, ref) => {
	const { label, id, required, error, ...rest } = props;
	return (
		<>
			<div className="mb-6">
				<label
					htmlFor={id}
					className="block mb-2 text-sm font-medium text-gray-900"
				>
					{label}
				</label>
				<input
					className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
					placeholder={label}
					id={id}
					{...rest}
					ref={ref}
				/>
				{<FormError error={error} />}
			</div>
		</>
	);
});
export function FormError({ error }: { error?: string | FieldError }) {
	const message = typeof error === "string" ? error : error ? error.message : error;
	if (!message) return null;

	return <ErrorMessage message={message} />;
}
